module.exports = __webpack_public_path__ + "media/images/debbite-11946289faed92018107f042faa7f48e.jpg";